// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"SubTitle_subTitle__ErhGr","pageSubtitle":"SubTitle_pageSubtitle__q1ZTd"};